// src/apiService.js
import axios from 'axios'; // Make sure this line is present

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`; // Replace with your actual API base URL

const getAuthKey = () => {
    return `${process.env.REACT_APP_API_SECURITY_KEY}`;
  };

export const addCustomerUploadData = async (formData) => {
    try {
        const response = await fetch(`${API_BASE_URL}/client/customer/customerupload`, {
            method: 'POST',
            headers: {
                'auth_key': `${getAuthKey()}`,
              },
            body: formData, // Pass the FormData directly without setting 'Content-Type'
        });

        if (!response.ok) {
            alert('Network response was not ok');
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        if (data.statusCode === 1002) {
            return { error: data.result };
        } else if (data.statusCode === 1001) {
            return { success: data.result };
        } else {
            return { error: data.result };
        }
    } catch (error) {
        console.error('Error submitting form:', error);
        throw error;
    }
};


// Fetch all countries from the API
export const fetchSubClientData = async (clientId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/client/subclient/getsubclientsbyclientid/${clientId}`,
        {
            headers: {
        'auth_key': `${getAuthKey()}`,
      }
    });
    return response.data; // Return the list of countries
  } catch (error) {
    console.error('Error fetching countries:', error);
    alert('Error fetching countries:'+ error);
    throw error;
  }
};

export const getFilesListByFilters = async (req) => {
    try {
        const response = await fetch(`${API_BASE_URL}/client/customer/getfileslist`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
                'auth_key': `${getAuthKey()}`,
              },
              body: JSON.stringify(req),
            });
            if (!response.ok) {
                alert('Network response was not ok');
                throw new Error('Network response was not ok');
            }
    
            const data = await response.json();
            if (data.statusCode === 1002) {
                return { error: data.result };
            } else if (data.statusCode === 1001) {
                return { success: data.result };
            } else {
                return { error: 'Fail' };
            }
        } catch (error) {
          console.error('Error fetching :', error);
          alert('Error fetching :'+ error);
          throw error;
        }
      };

      export const fetchRoleData = async (clientId) => {
        try {
          const response = await axios.get(`${API_BASE_URL}/admin/roles/getroleslist/${clientId}`,
            {
              headers: {
                'auth_key': `${getAuthKey()}`,
              }
            }
          );
          return response.data; // Return the list of countries
        } catch (error) {
          console.error('Error fetching countries:', error);
          alert('Error fetching countries:'+ error);
          throw error;
        }
      };

      export const fetchUserDataByClient = async (clientId) => {
        try {
          const response = await axios.get(`${API_BASE_URL}/admin/users/getusersbyclientid/${clientId}`,
            {headers: {
                'auth_key': `${getAuthKey()}`,
              }}
          );
          return response.data; // Return the list of countries
        } catch (error) {
          console.error('Error fetching countries:', error);
          alert('Error fetching countries:'+ error);
          throw error;
        }
      };

      export const assignFileDetailsToFO = async (req) => {
        try {
            const response = await fetch(`${API_BASE_URL}/client/customer/fileassigning`, {
                method: 'POST',
                headers: {
                    'auth_key': `${getAuthKey()}`,
                  },
                  body: req,
                });
    
            if (!response.ok) {
                alert('Network response was not ok');
                throw new Error('Network response was not ok');
            }
    
            const data = await response.json();
            if (data.statusCode === 1002) {
                return { error: data.result };
            } else if (data.statusCode === 1001) {
                return { success: data.result };
            } else {
                return { error: 'Fail' };
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            throw error;
        }
    };


    export const getAssignedFilesListByFilters = async (req) => {
      try {
          const response = await fetch(`${API_BASE_URL}/client/customer/getAssignedfileslist`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                  'auth_key': `${getAuthKey()}`,
                },
                body: JSON.stringify(req),
              });
              if (!response.ok) {
                  alert('Network response was not ok');
                  throw new Error('Network response was not ok');
              }
      
              const data = await response.json();
              if (data.statusCode === 1002) {
                  return { error: data.result };
              } else if (data.statusCode === 1001) {
                  return { success: data.result };
              } else {
                  return { error: 'Fail' };
              }
          } catch (error) {
            console.error('Error fetching :', error);
            alert('Error fetching :'+ error);
            throw error;
          }
        };

        export const fetchUploadedDataByFD = async (fileDetailsId) => {
          try {
            const response = await axios.get(`${API_BASE_URL}/client/customer/getuplodedfiledata/${fileDetailsId}`,
              {
                headers: {
                  'auth_key': `${getAuthKey()}`,
                }
              }
            );
            //console.log(response);
             const data = await response.data;
             //console.log(data);
             return data;
           
          } catch (error) {
            console.error("Error fetching template:", error);
          }
        };
  

        
export const getMinimumApprovedCustomerByFilters = async (req) => {
  try {
      const response = await fetch(`${API_BASE_URL}/client/office/getapprovedfilesbyorganization`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
              'auth_key': `${getAuthKey()}`,
            },
            body: JSON.stringify(req),
          });
          if (!response.ok) {
              alert('Network response was not ok');
              throw new Error('Network response was not ok');
          }
  
          const data = await response.json();
          if (data.statusCode === 1002) {
              return { error: data.result };
          } else if (data.statusCode === 1001) {
              return { success: data.result };
          } else {
              return { error: 'Fail' };
          }
      } catch (error) {
        console.error('Error fetching :', error);
        alert('Error fetching :'+ error);
        throw error;
      }
    };

    export const downloadCustomerFinalPdf = async (checkinId) => {
      try {
        const response = await axios.get(`${API_BASE_URL}/client/office/getCustomerFileTemplate/${checkinId}`, {
          headers: {
            'auth_key': `${getAuthKey()}`,
          },
          responseType: 'blob' // Ensure the response is received as a blob
        });
    
        // Create a blob URL and trigger the download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", checkinId+".pdf"); // Set the file name
        document.body.appendChild(link);
        link.click();
        link.remove(); // Clean up the link element
      } catch (error) {
        console.error("Error downloading PDF:", error);
        alert("Failed to download PDF. Please try again.");
      }
    };


         
export const getTeleVerificationListByFilters = async (req) => {
  try {
      const response = await fetch(`${API_BASE_URL}/client/office/getteleverificationfilesbyorganization`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
              'auth_key': `${getAuthKey()}`,
            },
            body: JSON.stringify(req),
          });
          if (!response.ok) {
              alert('Network response was not ok');
              throw new Error('Network response was not ok');
          }
  
          const data = await response.json();
          if (data.statusCode === 1002) {
              return { error: data.result };
          } else if (data.statusCode === 1001) {
              return { success: data.result };
          } else {
              return { error: 'Fail' };
          }
      } catch (error) {
        console.error('Error fetching :', error);
        alert('Error fetching :'+ error);
        throw error;
      }
    };



    
    export const saveFileComponentValues = async (req) => {
      try {
        req.userId = localStorage.getItem('userID');
         const response = await fetch(`${API_BASE_URL}/api/verificationFields/componentformsave`, {
          method: 'POST',
          headers: {
            'auth_key': `${getAuthKey()}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(req),
        });
    
        if (!response.ok) {
          alert('Network response was not ok');
          throw new Error('Network response was not ok');
        }
    
        const data = await response.json();
       // Check for specific status codes in the response
        //const data = {'statusCode': 1002,'result': 'success'};
        if (data.statusCode === 1002) {
          // Returning a specific error message if the user already exists
          return { error: data.result };
        }else if(data.statusCode===1001){
          return { success: 'Added Successfully' };
        }else if(data.statusCode===1005){
          return { error: data.result };
        }else{
          return { error: 'Fail' };
        }
        return data; // Return the API response
      } catch (error) {
        console.error('Error submitting form:', error);
        throw error; // Re-throw the error for handling in the component
      }
    };


    export const submitFileComponentValues = async (req) => {
      try {
        req.userId = localStorage.getItem('userID');
        //console.log(JSON.stringify(req));
         const response = await fetch(`${API_BASE_URL}/api/verificationFields/componentformsubmit`, {
          method: 'POST',
          headers: {
            'auth_key': `${getAuthKey()}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(req),
        });
    
        if (!response.ok) {
          alert('Network response was not ok');
          throw new Error('Network response was not ok');
        }
    
        const data = await response.json();
       // Check for specific status codes in the response
        //const data = {'statusCode': 1002,'result': 'success'};
        if (data.statusCode === 1002) {
          // Returning a specific error message if the user already exists
          return { error: data.result };
        }else if(data.statusCode===1001){
          return { success: 'Added Successfully' };
        }else if(data.statusCode===1005){
          return { error: data.result };
        }else{
          return { error: 'Fail' };
        }
        return data; // Return the API response
      } catch (error) {
        console.error('Error submitting form:', error);
        throw error; // Re-throw the error for handling in the component
      }
    };


    export const updatefiledetails = async (req) => {
      try {
        const response = await fetch(`${API_BASE_URL}/client/customer/updatefiledetails`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'auth_key': `${getAuthKey()}`,
          },
          body: JSON.stringify(req),
      });
    
        if (!response.ok) {
          alert('Network response was not ok');
          throw new Error('Network response was not ok');
        }
    
        const data = await response.json();
       // Check for specific status codes in the response
        //const data = {'statusCode': 1002,'result': 'success'};
        if (data.statusCode === 1002) {
          // Returning a specific error message if the user already exists
          return { error: data.result };
        }else if(data.statusCode===1001){
          return { success: 'Added Successfully' };
        }else{
          return { error: data.result };
        }
        return data; // Return the API response
      } catch (error) {
        console.error('Error submitting form:', error);
        throw error; // Re-throw the error for handling in the component
      }
    };


    export const deletefiledetails = async (firstRequest, secondRequest) => {
      try {
        const response = await fetch(`${API_BASE_URL}/client/customer/deletefiledetails/${firstRequest}?userid=${secondRequest}`, {
          method: 'DELETE',
          headers: {
              'Content-Type': 'application/json',
              'auth_key': `${getAuthKey()}`,
          }
      });
    
        if (!response.ok) {
          alert('Network response was not ok');
          throw new Error('Network response was not ok');
        }
    
        const data = await response.json();
       // Check for specific status codes in the response
        //const data = {'statusCode': 1002,'result': 'success'};
        if (data.statusCode === 1002) {
          // Returning a specific error message if the user already exists
          return { error: data.result };
        }else if(data.statusCode===1001){
          return { success: 'Deleted Successfully' };
        }else{
          return { error: data.result };
        }
        return data; // Return the API response
      } catch (error) {
        console.error('Error submitting form:', error);
        throw error; // Re-throw the error for handling in the component
      }
    };

    export const getApprovedListByFilters = async (req) => {
      try {
          const response = await fetch(`${API_BASE_URL}/client/office/getapprovedfilesbyorganizationforupdate`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                  'auth_key': `${getAuthKey()}`,
                },
                body: JSON.stringify(req),
              });
              if (!response.ok) {
                  alert('Network response was not ok');
                  throw new Error('Network response was not ok');
              }
      
              const data = await response.json();
              if (data.statusCode === 1002) {
                  return { error: data.result };
              } else if (data.statusCode === 1001) {
                  return { success: data.result };
              } else {
                  return { error: 'Fail' };
              }
          } catch (error) {
            console.error('Error fetching :', error);
            alert('Error fetching :'+ error);
            throw error;
          }
        };

        export const getApprovedComponentsListByCheckinID = async (checkinId) => {
          try {
              const response = await fetch(`${API_BASE_URL}/client/office/getapprovedcomponentsbycheckinid/${checkinId}`, {
                    headers: {
                      'auth_key': `${getAuthKey()}`,
                    },
                    responseType: 'blob' // Ensure the response is received as a blob
                  });
                  if (!response.ok) {
                      alert('Network response was not ok');
                      throw new Error('Network response was not ok');
                  }
          
                  const data = await response.json();
                  if (data.statusCode === 1002) {
                      return { error: data.result };
                  } else if (data.statusCode === 1001) {
                      return { success: data.result };
                  } else {
                      return { error: 'Fail' };
                  }
              } catch (error) {
                console.error('Error fetching :', error);
                alert('Error fetching :'+ error);
                throw error;
              }
            };
            
            export const loadOptions = async (inputValue) => {
              try {
                const response = await axios.get(`${API_BASE_URL}/client/common/getcheckinids`, {
                  headers: {
                    'auth_key': `${getAuthKey()}`,
                  },
                  params: {
                    suggestions: inputValue,
                  },
                });
                
                // Assuming the response data is in the format you're expecting
                return response.data;
                
              } catch (error) {
                console.error('Error fetching data:', error);
                return [];
              }
            };


            export const getFileDetailsListByFilters = async (req) => {
              try {
                  const response = await fetch(`${API_BASE_URL}/client/office/getfilesdetailslistbyorganization`, {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                          'auth_key': `${getAuthKey()}`,
                        },
                        body: JSON.stringify(req),
                      });
                      if (!response.ok) {
                          alert('Network response was not ok');
                          throw new Error('Network response was not ok');
                      }
              
                      const data = await response.json();
                      if (data.statusCode === 1002) {
                          return { error: data.result };
                      } else if (data.statusCode === 1001) {
                          return { success: data.result };
                      } else {
                          return { error: 'Fail' };
                      }
                  } catch (error) {
                    console.error('Error fetching :', error);
                    alert('Error fetching :'+ error);
                    throw error;
                  }
                };
            